export default __webpack_public_path__ + "7e0e87c4a1eef2877ce3075aecca7152.svg";